import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { Box, FormControl, InputAdornment } from "@mui/material";

const PhoneNumberDialog = (props) => {
  const { title, description, open, onClose, onSubmit } = props;
  const [phone, setPhone] = useState("");
  const phonePrefix = "08";

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(phonePrefix + phone);
  };
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>

      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            autoFocus
            margin="dense"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            id="name"
            name="phone"
            label="No. Hp"
            type="tel"
            fullWidth
            variant="outlined"
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">{phonePrefix}</InputAdornment>
              ),
            }}
            onSubmit={handleSubmit}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button type="submit" onClick={handleSubmit}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PhoneNumberDialog;
